function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path 148477",
  d: "M16.157 25.408a1.053 1.053 0 0 0 1.062-1.051v-9.7a2.855 2.855 0 0 0 0-5.308V6.287a1.063 1.063 0 0 0-2.123 0V9.35a2.855 2.855 0 0 0 0 5.308v9.7a1.053 1.053 0 0 0 1.061 1.05zm4.789-6.857a2.877 2.877 0 0 0 1.792 2.654v3.185a1.063 1.063 0 0 0 2.123 0v-3.184a2.864 2.864 0 0 0 0-5.32V6.32a1.062 1.062 0 0 0-2.123 0v9.58a2.854 2.854 0 0 0-1.793 2.652zM8.515 25.408a1.046 1.046 0 0 0 1.062-1.017v-3.185a2.862 2.862 0 0 0 0-5.308V6.32a1.062 1.062 0 0 0-2.123 0v9.566a2.864 2.864 0 0 0 0 5.32v3.185a1.046 1.046 0 0 0 1.061 1.017zM14.8 12a1.36 1.36 0 0 1 2.721 0 1.36 1.36 0 0 1-2.721 0zm7.642 6.547a1.364 1.364 0 0 1 1.368-1.367 1.348 1.348 0 0 1 1.36 1.371 1.332 1.332 0 0 1-1.36 1.36 1.348 1.348 0 0 1-1.372-1.359zm-15.284 0a1.36 1.36 0 1 1 2.721 0 1.36 1.36 0 0 1-2.721 0z",
  transform: "translate(3.845 4.661)"
});

function SvgVerticalSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalSettings);
export default __webpack_public_path__ + "static/media/vertical-settings.4baac4ad.svg";
export { ForwardRef as ReactComponent };